export const QueryKeys = {
  GET_CURRENT_USER: 'GET_CURRENT_USER',
  GET_SCRAPER_USER: 'GET_SCRAPER_USER',
  GET_SCRAPER_JOBS: 'GET_SCRAPER_JOBS',
  GET_SCRAPER_LIST: 'GET_SCRAPER_LIST',
  GET_SCRAPER_STATS: 'GET_SCRAPER_STATS',
};
